import comp from "./ScrollableCarousel";
export default comp;
